import { render, staticRenderFns } from "./companyBranding.vue?vue&type=template&id=668d09bd&scoped=true"
import script from "./companyBranding.vue?vue&type=script&lang=js"
export * from "./companyBranding.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "668d09bd",
  null
  
)

export default component.exports